import styled from "styled-components";
import { Button as AntButton, Alert } from "antd";
import { ProgramOption as DefaultProgramOption } from "common/program_selector";

type HeadingWrapperProps = {
  "background-url": string;
};

export const Button = styled(AntButton)`
  background-color: #d3e8ff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-weight: bold;
  color: rgb(15 112 182);
`;

export const ButtonIcon = styled(AntButton)`
  background-color: #1070b6;
  border-color: #1070b6;
  &:hover {
    background-color: #d3e8ff;
  }
`;

export const HeadingWrapper = styled.div`
  min-height: 150px;
  background-color: #1070b6;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: left;
  padding-left: 8%;
  padding-right: 8%;
  padding-top: 50px;
  padding-bottom: 50px;
  background-image: ${(props: HeadingWrapperProps) =>
    props["background-url"] ? `url(${props["background-url"]})` : ""};
  background-repeat: repeat;
`;

export const Container = styled.div`
  margin-top: 36px;
`;

export const CardContainer = styled.div`
  background-color: #e4e4e4;
`;

export const CardTitle = styled.div`
  background-color: #d3e8ff;
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 9px;
  padding-bottom: 9px;
`;

export const CardTitleText = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #1070b6;
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 9px;
  padding-bottom: 9px;
  background-color: #ffffff;
`;

export const CreditAmountBigText = styled.span`
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0.8px;
  color: #282828;
`;

export const ExpireText = styled.span`
  font-size: 14px;
  color: #1070b6;
  font-weight: bold;
  letter-spacing: 0.3px;
`;

export const CreditItem = styled.div`
  border: 2px solid #1070b6;
  background-color: #d3e8ff;
  font-size: 18px;
  font-weight: bold;
  color: #1070b6;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ProgramOption = styled(DefaultProgramOption)`
  background-color: ${(props) => (props.checked ? "#D3E8FF" : "#FFFFFF")};
  & span.ant-radio-disabled,
  input.ant-radio-input,
  span.ant-radio-inner,
  div.ant-row {
    cursor: pointer;
  }
`;

export const TableProgramHeader = styled(ProgramOption)<{ renew: boolean }>`
  margin-bottom: -1.5px;
  margin-top: 0;
  margin-right: -0.5px;
  background-color: ${(props) => (props.renew ? "#d3e8ff" : "#D3D3D3")};
  border: 2px solid ${(props) => (props.renew ? "#1070b6" : "gray")};
  & span.ant-radio-inner::after {
    background-color: ${(props) => (props.renew ? "#1070b6" : "gray")};
  }
`;

export const PrePurchaseBanner = styled(Alert)`
  background-color: #fdd440;
  text-align: center;
  border: none;
  & div.ant-alert-message {
    color: #1070b6;
    font-size: 16px;
    font-weight: bold;
  }
`;

export const NoPaymentMethodAlert = styled(Alert)`
  background-color: #fde48a;
  padding-top: 10px;
  & span.ant-alert-icon,
  div.ant-alert-message {
    margin-right: 12px;
    color: #1070b6;
    font-size: 18px;
    font-weight: bold;
  }
`;

export const LittleBoxWrapper = styled.div<{ renew: boolean }>`
  background-color: ${(props) => (props.renew ? "#d3e8ff" : "#D3D3D3")};
  border: 2px solid ${(props) => (props.renew ? "#1070b6" : "gray")};
  color: ${(props) => (props.renew ? "#1070b6" : "gray")};
  text-align: center;
  margin-right: -2px;
  height: 100%;
  padding: 5px;
`;

export const LittleBoxHeader = styled.h2<{ renew: boolean }>`
  color: ${(props) => (props.renew ? "#1070b6" : "gray")};
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 5px;
`;

export const LittleBoxDescription = styled.h1<{ renew: boolean }>`
  color: ${(props) => (props.renew ? "#1070b6" : "gray")};
  font-size: 27px;
  font-weight: bold;
  margin-bottom: 4px;
  padding-left: 5px;
`;

export const LittleBoxCurrency = styled.span<{ renew: boolean }>`
  color: ${(props) => (props.renew ? "#1070b6" : "gray")};
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 0;
`;
